import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const CalendarLiner24 = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8 2V5M16 2V5M8 11H16M8 16H12M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
